import { render, staticRenderFns } from "./FooterSocialLinks.vue?vue&type=template&id=be568a9e&scoped=true&"
import script from "./FooterSocialLinks.vue?vue&type=script&lang=js&"
export * from "./FooterSocialLinks.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocialLinks.vue?vue&type=style&index=0&id=be568a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be568a9e",
  null
  
)

export default component.exports